import {css} from '@logistics-frontend/blocks/theme/css'

export const classes = {
  root: css`
    background-color: #ff0004 !important;
    color: white !important;
  `,
}
